export function mapClipperSeasonError(message: string): 'overlap' | 'datesLocked' | 'generic' {
  if (message.includes('season_overlap')) return 'overlap';
  if (message.includes('season_dates_locked')) return 'datesLocked';
  return 'generic';
}
